export default __webpack_public_path__ + "static/media/industry-types.fe009b85.svg";